import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import * as moment from 'moment';
import { merge, of as observableOf } from 'rxjs';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';
import { ITutorLegal } from 'src/app/shared/Entities/ITutorLegal';
import { ProductService } from 'src/app/shared/services/product.service';
import { IColumnsDataTable } from 'src/app/shared/Entities/entities';
@Component({
  selector: 'app-tutor-legal',
  styleUrls: ['tutor-legal.component.sass'],
  templateUrl: 'tutor-legal.component.html',
})
export class TutorLegalComponent implements AfterViewInit, OnChanges {
  @Input() idPoliza: string;
  @Input() tipoSeguro: string;
  @Input() lineaNegocio: string;
  @Input() numPersona: string;
  @Input() tabActive: boolean;
  @Output() getPrintData$ = new EventEmitter();

  dataTable: ITutorLegal[] = [];
  data = {} as ITutorLegal;

  loading = false;
  error = false;

  displayedColumns = [
    {
      ColumnDef: 'Nombre',
      ColumnName: 'NOMBRE TUTOR',
    },
    {
      ColumnDef: 'rut',
      ColumnName: 'RUT',
    },
    {
      ColumnDef: 'InicioVigenciaUI',
      ColumnName: 'INICIO VIGENCIA',
    },
    {
      ColumnDef: 'FinVigenciaUI',
      ColumnName: 'FIN VIGENCIA',
    },
    {
      ColumnDef: 'ViaPago',
      ColumnName: 'FORMA DE PAGO',
    },
    {
      ColumnDef: 'Banco',
      ColumnName: 'BANCO',
    },
    {
      ColumnDef: 'NumeroCuenta',
      ColumnName: 'Nº CUENTA',
    },
    {
      ColumnDef: 'Direccion',
      ColumnName: 'DIRECCIÓN',
    },
    {
      ColumnDef: 'Comuna',
      ColumnName: 'COMUNA',
    },
    {
      ColumnDef: 'Ciudad',
      ColumnName: 'CIUDAD',
    },
    {
      ColumnDef: 'Oficina',
      ColumnName: 'OFICINA',
    },
  ] as IColumnsDataTable[];

  constructor(private productService: ProductService) {}
  ngOnChanges() {
    this.sendPrintData();
  }

  sendPrintData() {
    if (this.tabActive) {
      this.getPrintData$.emit(this.print());
    }
  }
  ngAfterViewInit(): void {
    merge()
      .pipe(
        startWith({}),
        switchMap(() => {
          this.loading = true;
          return this.productService.getTutorLegal(
            this.idPoliza,
            this.tipoSeguro,
            this.numPersona
          );
        }),
        map(data => {
          this.loading = false;
          this.error = false;
          return data;
        }),
        catchError(() => {
          this.loading = false;
          this.error = true;
          return observableOf({} as ITutorLegal);
        })
      )
      .subscribe(data => {
        if (data) {
          data.InicioVigenciaUI = moment(
            data.InicioVigenciaUI,
            'DD-MM-YYYY'
          ).format('DD-MM-YYYY');
          data.FinVigenciaUI = moment(data.FinVigenciaUI, 'DD-MM-YYYY').format(
            'DD-MM-YYYY'
          );
        }

        this.dataTable = data ? [data] : [];
        this.data = data;
        this.sendPrintData();
      });
  }

  print() {
    if (this.error || !this.data) {
      return null;
    }

    return [
      {
        type: 'logo',
        content: {
          halign: 'right',
        },
      },
      {
        type: 'title',
        content: {
          text: `CARGAS FAMILIARES`,
          halign: 'left',
        },
      },
      {
        type: 'table',
        width: 100,
        content: {
          size: {
            columns: [15, 35, 15, 35],
          },
          table: [
            [
              { value: 'Nombre', type: 'header', halign: 'left' },
              { value: this.data.Nombre, halign: 'left' },
              { value: 'Inicio de vigencia', type: 'header', halign: 'left' },
              { value: moment(this.data.InicioVigencia).format('DD-MM-YYYY') },
            ],
            [
              { value: 'Rut', type: 'header', halign: 'left' },
              { value: this.data.rut, halign: 'left' },
              { value: 'Direccion', type: 'header', halign: 'left' },
              { value: this.data.Direccion, halign: 'left' },
            ],
            [
              { value: 'Banco', type: 'header', halign: 'left' },
              { value: this.data.Banco, halign: 'left' },
              { value: 'Comuna', type: 'header', halign: 'left' },
              { value: this.data.Comuna, halign: 'left' },
            ],
            [
              { value: 'Forma de Pago', type: 'header', halign: 'left' },
              { value: this.data.ViaPago, halign: 'left' },
              { value: 'Region', type: 'header', halign: 'left' },
              { value: this.data.Region, halign: 'left' },
            ],
            [
              { value: 'Cuenta Bancaria', type: 'header', halign: 'left' },
              { value: this.data.NumeroCuenta, halign: 'left' },
              { value: 'Oficina', type: 'header', halign: 'left' },
              { value: this.data.Oficina, halign: 'left' },
            ],
          ],
        },
      },
    ];
  }
}
